import * as React from 'react';

import { createIcon } from '../Icon';
export const PlayIcon = createIcon(
  <polygon points="5 3 19 12 5 21 5 3" />,
  'PlayIcon'
);
